import { getMomentUTC } from "sharedFunctions/sharedFunctions";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { env } from "env";

function Footer() {
	return (
		<Box
			component="footer"
			sx={{
				mt: 1,
				px: { xs: 1.5, sm: 2 },
				py: 1.5,
				textAlign: "center",
				bgcolor: "transparent",
				backdropFilter: "saturate(140%) blur(8px)",
				WebkitBackdropFilter: "saturate(140%) blur(8px)",
				borderTop: "1px solid",
				borderColor: "divider",
			}}
		>
			<Stack
				direction={{ xs: "column", sm: "row" }}
				spacing={1.5}
				sx={{
					alignItems: "center",
					justifyContent: "space-between",
					maxWidth: 1240,
					mx: "auto",
				}}
			>
				<Typography
					variant="caption"
					sx={{
						color: "text.secondary",
					}}
				>
					{`Made by Stilet 2021 - ${getMomentUTC().format("YYYY")}`}
				</Typography>
				<Divider
					flexItem
					orientation="vertical"
					sx={{ display: { xs: "none", sm: "block" } }}
				/>
				<Typography
					variant="caption"
					sx={{
						color: "text.secondary",
					}}
				>
					{`Version ${env.sunriseAgencyVersion}`}
				</Typography>
			</Stack>
		</Box>
	);
}

export default Footer;
